import React from 'react';
import './TendersIntro.css';

const TendersIntro = () => {
  return (
    <section className="tenders-intro-section">
      <div className="tenders-intro-container">
        <div className="section-header">
          <h2>One platform for all Indian Notifications</h2>
          <div className="header-line"></div>
        </div>
        <p className="section-subtitle">
          Get instant updates, customized alerts, and smart insights to enhance your bidding success.
        </p>
      </div>
    </section>
  );
};

export default TendersIntro;